var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Companies"},[_c('div',{staticClass:"slide"},[_c('div',{staticClass:"bg-img"},[_c('div',{staticClass:"slide-content"},[_c('h2',{staticClass:"slide-header"},[_vm._v(" Companies")]),_c('p')])])]),_c('h1')])
}]

export { render, staticRenderFns }